import Projects_ProjectsPage from "@Projects/Pages/ProjectsPage.vue";
import Projects_ProjectTemplateDownloadPage from "@Projects/Pages/ProjectTemplateDownloadPage.vue";


export const routes = [
    {
        path: "/projects/:workspaceId",
        component: Projects_ProjectsPage
    }, 
    {
        path: "/download-project-template/:accessKey",
        component: Projects_ProjectTemplateDownloadPage
    },
]
